/* eslint-disable @typescript-eslint/no-explicit-any */
class SafeDataObject {
  private data: Record<string, any>;

  constructor(jsonValue: Record<string, any> | string | unknown) {
    if (typeof jsonValue === 'string') {
      try {
        this.data = JSON.parse(jsonValue);
      } catch (e) {
        this.data = {};
      }
    } else {
      this.data = typeof jsonValue === 'object' && jsonValue !== null ? jsonValue : {};
    }
  }

  get<T>(key: string, defaultValue: T): T {
    return this.data[key] ?? defaultValue;
  }

  getNested<T>(parentKey: string, childKey: string, defaultValue: T): T {
    return this.data[parentKey]?.[childKey] ?? defaultValue;
  }

  set<T>(key: string, value: T): SafeDataObject {
    return new SafeDataObject(
      JSON.stringify(
        {
          ...this.data,
          [key]: value,
        },
        null,
        2
      )
    );
  }

  setNested<T>(parentKey: string, childKey: string, value: T): SafeDataObject {
    return new SafeDataObject(
      JSON.stringify(
        {
          ...this.data,
          [parentKey]: {
            ...(this.data[parentKey] || {}),
            [childKey]: value,
          },
        },
        null,
        2
      )
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toJSON(): Record<string, any> {
    return this.data;
  }

  toString(): string {
    return JSON.stringify(this.data, null, 2);
  }
}

export default SafeDataObject;
